import { ReactRenderer } from "@tiptap/react";
import tippy from "tippy.js";

import { tooltipZIndex } from "@helpers/constants";

import { CommandList } from "./commands-helpers";

export const renderItems = () => {
  let component: any;
  let popup: any;

  return {
    onStart: (props: any) => {
      component = new ReactRenderer(CommandList, {
        props,
        editor: props.editor,
      });

      popup = tippy("body", {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: component.element,
        showOnCreate: true,
        interactive: true,
        trigger: "manual",
        placement: "bottom-start",
        theme: "headless",
        zIndex: tooltipZIndex,
      });
    },
    onUpdate(props: any) {
      component.updateProps(props);
      popup[0].setProps({
        getReferenceClientRect: props.clientRect,
      });
    },
    onKeyDown(props: any) {
      if (props.event.key === "Escape") {
        popup[0].hide();
        return true;
      }
      return component.ref?.onKeyDown(props);
    },
    onExit() {
      if (popup[0]) {
        if (!popup[0].state.isDestroyed) {
          popup[0].destroy();
        }
      }
      component.destroy();
    },
  };
};
